import React from 'react';
import { HeroPicture } from '@/components/HeroPicture';
import heroMobile from '@public/img/b2c/equity-release/hero-mob.webp';
import heroTablet from '@public/img/b2c/equity-release/hero-tab.webp';
import heroDesktop from '@public/img/b2c/equity-release/hero-desktop.webp';

export const Hero = () => (
  // xl:mb-8 matches the magenta panel's 2rem overhang below the image, so the gap is measured from the panel
  <div className="container mx-auto lg:flex lg:items-center lg:pt-2 lg:gap-16 lg:relative xl:mb-8">
    <div className="lg:w-[28.5rem] lg:z-10 xl:w-[32.5rem]">
      <h1 className="text-[#A51367] font-semibold text-xl mb-3 mt-4 lg:mt-0">
        Equity release
      </h1>
      <h2 className="text-4xl md:text-5xl text-[#373945] font-semibold mb-6">
        Start Your <span className="text-[#8D1558]">Later Life Borrowing Journey</span>
      </h2>

      <p className="text-base text-[#373945] font-450 lg:mb-0">
        For individuals over 55, equity release serves as a later life finance option, and
        we are committed to ensuring you have the information you need before you start.
        Learn more about lifetime mortgages, how they work, and common later life finance
        terminology.
      </p>
    </div>

    <div className="w-full relative mt-8 lg:w-1/2 lg:mt-0">
      {/* Image Container */}
      <div className="w-full rounded-xl overflow-hidden lg:relative lg:z-10">
        <HeroPicture
          mobile={heroMobile}
          tablet={heroTablet}
          desktop={heroDesktop}
          alt="Happy senior couple planning their future"
          fill={false}
          sizes="(min-width: 1024px) 50vw, 100vw"
          className="rounded-xl"
        />
      </div>

      {/* Magenta Background */}
      <div className="hidden xl:block absolute top-[10rem] right-[-2rem] bottom-[-2rem] w-[90%] bg-[#8D1558] z-0 rounded-t-xl" />
    </div>
  </div>
);
